import '../scss/main.scss';

function mobileNavToggle() {
  const openClass = 'mobile-menu--open';
  const bodyElClassList = document.body.classList;
  const mobileNavToggleEl = document.querySelector('.header__nav-toggle');
  const mobileNavLinkElements = document.querySelectorAll('.header__nav a');

  mobileNavToggleEl.addEventListener('click', (event) => {
    event.preventDefault();

    if (bodyElClassList.contains(openClass)) {
      bodyElClassList.remove(openClass);
    } else {
      bodyElClassList.add(openClass);
    }
  });

  mobileNavLinkElements.forEach((element) => {
    element.addEventListener('click', () => {
      if (bodyElClassList.contains(openClass)) {
        bodyElClassList.remove(openClass);
      }
    });
  });
}

function initializeModal() {
  const modalEl = document.getElementById('modal');
  const closeButtonEl = document.createElement('a');

  if (modalEl) {
    closeButtonEl.setAttribute('href', '#');
    closeButtonEl.classList.add('modal--close');
    modalEl.querySelector('.modal').prepend(closeButtonEl);

    if (!modalEl.classList.contains('modal--visible') && window.sessionStorage.getItem('infoModal') !== 'true') {
      window.setTimeout(() => {
        modalEl.classList.add('modal--visible');
        window.sessionStorage.setItem('infoModal', true);
      }, 800);
    }

    closeButtonEl.addEventListener('click', (event) => {
      event.preventDefault();

      if (modalEl.classList.contains('modal--visible')) {
        modalEl.classList.remove('modal--visible');
      }
    });
  }
}

function linkList() {
  const linkListElements = document.querySelectorAll('.ce_rsce_link_submenu');

  linkListElements.forEach((element) => {
    const linkEl = element.querySelector('.link-submenu__image a');
    const linkNavEl = element.querySelector('.link-submenu__nav');

    linkEl.addEventListener('click', (event) => {
      event.preventDefault();

      if (linkNavEl.classList.contains('open')) {
        linkNavEl.classList.remove('open');
      } else {
        linkNavEl.classList.add('open');
      }
    });
  });
}

mobileNavToggle();
initializeModal();
linkList();
